import { getBaseUrl, getRequestWithTokenInformation } from "services/common";
import { RequestInit } from "atoms/models";

export const getServiceAgreement = async () => {
  const baseUrl = getBaseUrl();
  const relativeUrl = "ecommerce/getServiceAgreement";
  const input = new URL(relativeUrl, baseUrl).href;
  const headers = new Headers();
  headers.append("Accept", "text/html, application/xhtml+xml");
  const init: RequestInit = getRequestWithTokenInformation("GET", headers);
  const response = await window.fetch(input, init);
  const text = await response.text();
  return text;
};
